import React, { useContext } from "react";
import MetaTags from "react-meta-tags";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Col, Container, Row } from "reactstrap";
import Organisations from "./Organisations";
import { ThemeContext } from "src/helpers/themeContext";

const OrganisationsPage = () => {
    const Theme = useContext(ThemeContext)
    return  (
        
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Organisations | {Theme.name} organisations</title>
                </MetaTags>

                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Home" breadcrumbItem="Organisations" />

                    <Row>
                        <Col lg={12}>
                            <Organisations />
                        </Col>
                    </Row>

                    
                </Container>
            </div>
        </React.Fragment>
    );
}

export default OrganisationsPage;